import * as React from 'react'
import * as moment from 'moment'
import { Grid, FormControlLabel, MenuItem, Radio } from '@material-ui/core'
import { Field, reduxForm, InjectedFormProps, change, formValueSelector } from 'redux-form'
import { TextField, RadioGroup, Select } from 'redux-form-material-ui'
import autobind from 'autobind-decorator'
import { compose } from 'redux'
import {WithI18n, withI18n} from 'src/core/i18n/withI18n'
import {connect} from 'react-redux'
import { QuestionWpr } from 'src/shared/form/QuestionWpr'
import Alert from 'src/shared/Alert/Alert'
import DateField from 'src/shared/form/DateField'
import CurrencyField from 'src/shared/form/CurrencyField'
import { ITermeParticipatifAsymetrique, currenciesExchange, frequenceFixings } from 'src/type/cotation-form'
import { Validator } from 'src/core/form/Validator'
import { parseNumber, restrictCurrenciesExchange } from 'src/shared/utils/helpers'
import PositiveNumberField from 'src/shared/form/PositiveNumberField'


const validate = values => Validator.buildWithCheckAll(values, {
    devise: [Validator.required],
    sens: [Validator.required],
    date_echeance: [Validator.required],
    date_de_livraison: [Validator.required],
    style_de_barriere: [Validator.required],
    montant_minimum: [Validator.positiveNumber],
    montant_maximum: [Validator.positiveNumber],
    strike: [Validator.positiveNumber],
    ki: [Validator.positiveNumber],
}, checkAll);

const checkAll = (values) => {
    if(
        (values.date_de_livraison && values.date_echeance && moment(values.date_de_livraison).isBefore(values.date_echeance)) ||
        (values.montant_maximum && values.montant_minimum && values.montant_maximum < values.montant_minimum) 
    ){
        return "form error"
    } else {
        return undefined
    }
}

interface IProps extends WithI18n,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
  onSubmit: (values: any) => void;
}


class TermeParticipatifAsymetriqueForm extends React.Component<IProps & InjectedFormProps<ITermeParticipatifAsymetrique>, {}> {


    render(){
        const {onSubmit, strike, ki, dateLivraison, dateEcheance, sens, devise, montantMin, montantMax, styleDeBarriere, nombreEcheances, enterprise} = this.props
        return(
            <form onSubmit={onSubmit}>
                <Grid container>
                    <Grid item xs={12}>
                        <QuestionWpr
                            label="Couple de devises"
                            isRequired={true}
                        >
                            <Field
                                name="devise"
                                component={Select}
                                fullWidth={true}
                            >
                                {this.renderSelectItemByArr(restrictCurrenciesExchange(enterprise.chequing_account_currencies ,currenciesExchange))}
                            </Field>
                        </QuestionWpr>

                        <QuestionWpr
                            label={`Import/Export ${this.generateDevise()}`}
                            isRequired={true}
                            isCheckBox={true}
                        >
                            <Field
                                name="sens"
                                component={RadioGroup}
                            >
                                <FormControlLabel
                                    value="import"
                                    control={<Radio color="primary" />}
                                    label="import"
                                />
                                <FormControlLabel
                                    value="export"
                                    control={<Radio color="primary" />}
                                    label="export"
                                />
                            </Field>
                        </QuestionWpr>

                        <QuestionWpr
                            label={`Montant minimum ${devise ? "(" + devise.toString().substring(4) + ")" : ""}`}
                        >
                            <Field
                                name="montant_minimum"
                                component={CurrencyField}
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label={`Montant maximum ${devise ? "(" + devise.toString().substring(4) + ")" : ""}`}
                        >
                            <Field
                                name="montant_maximum"
                                component={CurrencyField}
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="Strike"
                        >
                            <Field
                                name="strike"
                                type="number"
                                component={TextField}
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="KI"
                        >
                            <Field
                                name="ki"
                                type="number"
                                component={TextField}
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="Style de barrière"
                            isRequired={true}
                            isCheckBox={true}
                        >
                            <Field
                                name="style_de_barriere"
                                component={RadioGroup}
                            >
                                <FormControlLabel
                                    value="européenne"
                                    control={<Radio color="primary" />}
                                    label="européenne"
                                />
                                <FormControlLabel
                                    value="américaine"
                                    control={<Radio color="primary" />}
                                    label="américaine"
                                />
                                <FormControlLabel
                                    value="à fenêtre"
                                    control={<Radio color="primary" />}
                                    label="à fenêtre"
                                />
                            </Field>
                        </QuestionWpr>

                        {styleDeBarriere === "à fenêtre" &&
                            <>
                                <QuestionWpr
                                    label="Date de début de la fenêtre"
                                >
                                    <Field
                                        name="date_de_debut_de_la_fenetre"
                                        component={DateField}
                                        fullWidth={true}
                                    />
                                </QuestionWpr>

                                <QuestionWpr
                                    label="Date de fin de la fenêtre"
                                >
                                    <Field
                                        name="date_de_fin_de_la_fenetre"
                                        component={DateField}
                                        fullWidth={true}
                                    />
                                </QuestionWpr>
                            </>
                        }

                        <QuestionWpr
                            label="Date d'échéance"
                            isRequired={true}
                        >
                            <Field
                                name="date_echeance"
                                component={DateField}
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="Date de livraison"
                            isRequired={true}
                        >
                            <Field
                                name="date_de_livraison"
                                component={DateField}
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="Nombre d'échéances"
                        >
                            <Field
                                name="nombre_echeances"
                                component={PositiveNumberField}
                                type="number"
                                min={1}
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        {nombreEcheances > 1 &&
                            <QuestionWpr
                                label="Fréquence échéances"
                            >
                                <Field
                                    name="frequence_echeances"
                                    component={Select}
                                    fullWidth={true}
                                >
                                    {this.renderSelectItemByArr(frequenceFixings)}
                                </Field>
                            </QuestionWpr>
                        }


                        <QuestionWpr
                            label="Commentaire"
                        >
                            <Field
                                name="commentaire"
                                component={TextField}
                                fullWidth={true}
                            />
                        </QuestionWpr>
                        
                    </Grid>

                    {(
                        (dateLivraison && dateEcheance && moment(dateLivraison).isBefore(dateEcheance)) ||
                        (montantMax !== undefined && montantMin !== undefined && montantMax < montantMin)
                    ) &&
                        <Grid item xs={12}>
                            <Alert type="error">
                                {dateLivraison && dateEcheance && moment(dateLivraison).isBefore(dateEcheance) &&
                                    <p>La date de livraison doit être supérieure à la date d'échéance</p>
                                }
                                {montantMax !== undefined && montantMin !== undefined && montantMax < montantMin &&
                                    <p>Le montant minimum doit être inférieur ou égal au montant maximum</p>
                                }
                            </Alert>
                        </Grid>
                    }

                    {(
                        (strike !== undefined && ki !== undefined && sens === 'import' && ki <= strike) || 
                        (strike !== undefined && ki !== undefined && sens === 'export' && ki >= strike)
                    ) &&
                        <Grid item xs={12}>
                            <Alert type="info">
                                {strike !== undefined && ki !== undefined && sens === 'import' && ki <= strike &&
                                    <p>Le KI doit être supérieur au strike</p>
                                }
                                {strike !== undefined && ki !== undefined && sens === 'export' && ki >= strike &&
                                    <p>Le strike doit être supérieur au KI</p>
                                }
                            </Alert>
                        </Grid>
                    }
                </Grid>
            </form>
        )
    }

    componentDidUpdate(prevPros){
        const {dateEcheance, styleDeBarriere, nombreEcheances} = this.props;
        if(!!dateEcheance && prevPros.dateEcheance !== dateEcheance && moment(dateEcheance).isValid()){
            this.props.setValue('date_de_livraison', dateEcheance);
        }
        if(!!styleDeBarriere && prevPros.styleDeBarriere !== styleDeBarriere && styleDeBarriere !== "à fenêtre"){
            this.props.setValue('date_de_fin_de_la_fenetre', null);
            this.props.setValue('date_de_debut_de_la_fenetre', null);
        }
        if(!!nombreEcheances && prevPros.nombreEcheances !== nombreEcheances && nombreEcheances === 1){
            this.props.setValue('frequence_echeances', null);
        }
    }

    @autobind
    private generateDevise(){
        const {sens, devise} = this.props
        if(sens && devise){
            switch(sens){
                case 'import':
                    return ` (Achat ${devise.toString().substring(4)})`;
                case 'export':
                    return ` (Vente ${devise.toString().substring(4)})`;
                default:
                    return ''
            }
        } else {
            return ''
        }
    }

    @autobind
    private renderSelectItemByArr(arr: any[]){
        return arr.map(a => (
            <MenuItem key={a} value={a}>{a}</MenuItem>
        ))
    }

}

const formName = 'TERME_PARTICIPATIF_form';

const state2props = (state, props) => ({
    devise: formValueSelector(formName)(state, 'devise'),
    strike: parseNumber("float", formValueSelector(formName)(state, 'strike')),
    ki: parseNumber("float", formValueSelector(formName)(state, 'ki')),
    dateEcheance: formValueSelector(formName)(state, 'date_echeance'),
    dateLivraison: formValueSelector(formName)(state, 'date_de_livraison'),
    montantMax: parseNumber("float", formValueSelector(formName)(state, 'montant_maximum')),
    montantMin: parseNumber("float", formValueSelector(formName)(state, 'montant_minimum')),
    sens: formValueSelector(formName)(state, 'sens'),
    styleDeBarriere: formValueSelector(formName)(state, 'style_de_barriere'),
    nombreEcheances: parseNumber("float", formValueSelector(formName)(state, 'nombre_echeances')),
    enterprise: state.accountInfo.enterpriseSelected
});

const dispatch2props = (dispatch: any) => ({
    setValue: (field, value) => dispatch(change(formName, field, value)),
});
  
export default compose(
    withI18n,
    connect(state2props, dispatch2props)
)(reduxForm<ITermeParticipatifAsymetrique, IProps>({
    form: formName,
    validate
})(TermeParticipatifAsymetriqueForm))



// WEBPACK FOOTER //
// ./src/shared/Cotation/form/TermeParticipatifAsymetriqueForm.tsx